export const LOCALE_CODE_RUSSIAN = 'ru-RU'
